<template>
    <div>
        <NavBar :articles="page.props.nav.articles" :tags="page.props.nav.tags"></NavBar>

        <slot />
    </div>

    <SiteFooter />
</template>

<script setup lang="ts">
/**
 * The frame every page is drawn inside: navigation at the top, footer at the
 * bottom, page content between. Applied automatically to every page, so no
 * page has to ask for it.
 */

import { usePage } from '@inertiajs/vue3'
import NavBar from '../components/NavBar.vue'
import SiteFooter from '../components/SiteFooter.vue'
import type { SharedProps } from '../types'

const page = usePage<SharedProps>()
</script>
